var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page-view"}},[_c('section',{staticClass:"bg-light  "},[_c('main',[_c('div',{staticClass:"container py-5"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.description)}})])])])])}
var staticRenderFns = []

export { render, staticRenderFns }